export const colors = {
    blue: '#3379c1',
    bluelight: '#688BA3',
    bluedark: '#1B3141',
    bluegreen: '#318495',
    grey: '#61717B',
    green: '#507B43',
    greendark: '#63715F',
    greenblue: '#46927D',
    indigo: '#4c3ce2',
    orange: '#ecaa15',
    orangelight: '#ff6600',
    orangedark: '#c59600',
    red: '#cc1212',
    redlight: '#f30707',
    reddark: '#8E111C',
    yellow: '#d1d432',
};
